import BigNumber from 'bignumber.js'
import { DEFAULT_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'
import getGasPrice from 'utils/getGasPrice'

const options = {
  gasLimit: DEFAULT_GAS_LIMIT,
}



export const mintNexItem = async (
  nexItemContract,
  walletAddress,
  nexItemId,
  price,
  amount
) => {
  const gasPrice = getGasPrice()
  const _userMaxMintSupply = '2';

  const response = await fetch(`.netlify/functions/ni-signatures-get?walletAddress=${walletAddress}&nexItemId=${nexItemId}&price=${price}`, {
    headers: {
      security: walletAddress
    }
  });
  const {signature, currentTimestamp} = await response.json();
// console.log(
//   walletAddress,
//   nexItemId,
//   amount,
//   price,
//   currentTimestamp,
//   signature
// )
  const tx = await nexItemContract.mintNexItem(
    walletAddress,
    nexItemId,
    amount,
    _userMaxMintSupply,
    price,
    currentTimestamp,
    signature,
    // {}
    { ...options, gasPrice }
  )
  const receipt = await tx.wait()
  return receipt.status
}
